import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

// Constantes para tipos de exame
export const EXAM_TYPES = {
  CFP: 'cfp',
  CFA: 'cfa'
};

// Constantes para categorias de curso
export const COURSE_CATEGORIES = {
  CFP: 1,
  CFA: 15 // Nova constante para CFA
};

// Constantes para tipos de relatório
export const REPORT_TYPES = {
  PDF: 1,
  PNG: 2
};

// Constantes para categorias de relatório
export const REPORT_CATEGORIES = {
  SIMULATED: 1,
  WEEKLY: 2
};

/**
 * Hook personalizado para detectar o tipo de exame baseado na rota atual
 * e fornecer configurações dinâmicas para CFP/CFA
 */
export const useExamType = () => {
  // Sempre chama useLocation - se falhar, será tratado pelo ErrorBoundary ou mock nos testes
  const location = useLocation();

  const examConfig = useMemo(() => {
    const pathname = location?.pathname || '';
    const searchParams = new URLSearchParams(location?.search || '');
    
    // Detecta o tipo de exame baseado na rota E nos parâmetros da URL
    let examType = EXAM_TYPES.CFP; // Default
    
    // Primeira prioridade: parâmetro na URL (ex: ?examType=cfa ou /cfa?...)
    const urlPath = pathname + location.search;
    if (urlPath.includes('/cfa') || searchParams.get('examType') === 'cfa') {
      examType = EXAM_TYPES.CFA;
    } else if (pathname.includes('/cfa-')) {
      examType = EXAM_TYPES.CFA;
    } else if (pathname.includes('/cfp-')) {
      examType = EXAM_TYPES.CFP;
    }

    // Configurações dinâmicas baseadas no tipo de exame
    const config = {
      examType,
      displayName: examType.toUpperCase(),
      courseCategory: examType === EXAM_TYPES.CFA ? COURSE_CATEGORIES.CFA : COURSE_CATEGORIES.CFP,
      
      // Endpoints dinâmicos
      endpoints: {
        report: `/v1/report/course/${examType}`,
        simulado: `/v1/report/course/${examType}/simulado`,
        weekly: `/v1/report/course/${examType}/weekly`,
        scoreToroSuggestions: `/v1/score-toro-suggestions/${examType}`
      },
      
      // Textos dinâmicos
      texts: {
        welcomeMessage: `Relatório ${examType.toUpperCase()}`,
        footerMessage: examType === EXAM_TYPES.CFA 
          ? 'Muito obrigado por escolher a Rafael Toro Academia de Finanças para sua preparação CFA :)'
          : 'Muito obrigado por escolher a Rafael Toro Academia de Finanças :)',
        examName: examType === EXAM_TYPES.CFA ? 'CFA' : 'CFP',
        fullExamName: examType === EXAM_TYPES.CFA 
          ? 'Chartered Financial Analyst' 
          : 'Certified Financial Planner'
      },
      
      // Configurações específicas
      settings: {
        recommendedScore: examType === EXAM_TYPES.CFA ? 75 : 70, // CFA pode ter score recomendado diferente
        maxModules: examType === EXAM_TYPES.CFA ? 10 : 8, // CFA tem 10 módulos, CFP tem 8
        colors: {
          primary: examType === EXAM_TYPES.CFA ? '#1890ff' : '#52c41a', // Cores diferentes por exame
          secondary: examType === EXAM_TYPES.CFA ? '#096dd9' : '#389e0d'
        }
      }
    };

    return config;
  }, [location.pathname, location.search]);

  return examConfig;
};

export default useExamType;
